export class RateLimiter {
  private timestamps: number[] = [];

  constructor(
    private readonly maxCalls: number,
    private readonly windowMs: number,
  ) {}

  /** True dönerse işleme izin verilir, false ise sınır aşılmıştır. */
  check(): boolean {
    const now = Date.now();
    this.timestamps = this.timestamps.filter((t) => now - t < this.windowMs);
    if (this.timestamps.length >= this.maxCalls) {
      return false;
    }
    this.timestamps.push(now);
    return true;
  }
}

// Global Skor Gönderim Limiti (Dk başına max 20 skor)
export const scoreSubmitLimiter = new RateLimiter(20, 60_000);
